// extracted by mini-css-extract-plugin
export default {"creditCardLogo":"CreditCardDisplay_creditCardLogo__J4vlG","iconCreditCard":"CreditCardDisplay_iconCreditCard__xKfTR"};